<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">THE NORTH FACE</div>
          <div class="contentBottom">
            <div>户外品牌的新零售探索</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <!-- <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>-->
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <div class="productRightTitle">
          <div class="titleBox1">
            <div class="anliTitle">项目背景</div>
            <div class="lineCss1"></div>
          </div>
        </div>
        <div
          class="productRightText paddingRight"
        >The North Face®北面，美国著名户外品牌，成立于1966年，致力于为户外运动员的每一次严酷探险提供专业装备。作为阿里新零售的战略的一环，The North Face希望能通过智能化改造，使消费者更为深入了解产品功能。</div>
      </div>
      <div class="productRight">
        <img :src="productLeft1" class="rightImgCss">
      </div>
    </div>
    <!-- end -->

    <div class="grayBox">
      <div class="titleBox" style="margin-top:0;">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div
        class="grayBoxText"
      >根据店铺产品陈列规则，划分出服饰、鞋履、试衣等候三大功能区域，分别为每个区域定制产品，接入电商数据，帮助顾客了解产品。通过综合传感器和RFID的接入，完成识别人脸、感知产品等交互动作。过程中所有数据，皆可留存，以供后续营销策划指导。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">数拓智屏OS</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon4" alt>
          <div class="detailBoxTitle">天猫数据对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon5" alt>
          <div class="detailBoxTitle">场景app</div>
        </div>
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:138px">场景解析</div>
      <div class="lineCss"></div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img :src="northFace2" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">服装区-抖衣</div>
        <div
          class="bottomRightText"
        >服装区交互屏幕，可通过“综合传感器识别到人+RFID感应到单品标签”触发。当顾客拿起任意单品站在屏前，即刻就会出现相关推荐搭配。同时，三块小浮窗在屏幕两侧列出搭配单品，点击小浮窗即可进入单品详情页。设备内置自分配系统，会在多人同时触发机器时，自动进行排序。排队单品会在屏幕上小窗显示7-12s。抖衣帮助The North Face打破户外品牌的固有印象，让消费者获取更多搭配灵感。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">鞋履区-鞋墙</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >鞋履陈列的墙壁上，安装一块接入第三方电商系统的交互触摸屏。顾客拿起任意鞋子，RFID感应到单品标签，即可在屏幕上浏览到详细产品信息。鞋墙帮助The North Face，详细讲解专业鞋履功能，辅助导购销售工作。</div>
      </div>

      <div class="bottomRight" style='width:50%;'>
        <img :src="wanDaContent3" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img :src="teBuContent5" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">试衣等候区-目的地推荐</div>
        <div
          class="bottomRightText"
        >试衣间入口处，装有一台落地式交互一体机，内置8大旅行目的地（根据对目标客群的分析，The North Face提炼出8大热门旅行目的地）。点击目的地，屏幕会显示该地区近1-2个月气候状况，并通过传感器识别男女，推荐相匹配的旅行装备。结合不同场景，不同着装需求，帮助顾客在The North Face找到最合适的单品。</div>
      </div>
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/northFaceTop.png";
import productLeft1 from "@/assets/images/northFace1.png";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/northFace3.png";
import wanDaContent4 from "@/assets/images/teBuContent3.png";
import detailListIcon1 from "@/assets/images/teBuIcon1.png";
import detailListIcon2 from "@/assets/images/teBuIcon2.png";
import detailListIcon3 from "@/assets/images/teBuIcon3.png";
import detailListIcon4 from "@/assets/images/teBuIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/northFace4.png";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import northFace2 from "@/assets/images/northFace2.png";
import Bread from "@/components/bread.vue";

export default {
  name: "CaseNorthFace",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
        northFace2:northFace2,
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "The North Face"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 888px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
  margin-bottom: 40px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 44%;
  padding-left: 6%;
  float: left;
}

.productLeft img {
  width: 98%;
  max-width: 542px;
}

.productRight {
  width: 46%;
  padding-left: 2%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  margin-top: 3px;
}

.marginTop109 {
  margin-top: 119px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
  text-indent: 40px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 170px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 46%;
  float: right;
  
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
  padding-left: 10%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  padding-left: 10%;

}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 70%;
  margin-top: 6%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  /* max-width: 618px; */
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
</style>



// WEBPACK FOOTER //
// src/view/CaseNorthFace.vue